import { render, staticRenderFns } from "./EskiSatisForm.vue?vue&type=template&id=20aa5da2&scoped=true"
import script from "./EskiSatisForm.vue?vue&type=script&lang=ts"
export * from "./EskiSatisForm.vue?vue&type=script&lang=ts"
import style0 from "./EskiSatisForm.vue?vue&type=style&index=0&id=20aa5da2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aa5da2",
  null
  
)

export default component.exports